import React from 'react'
import CloseButtonSVG from "../../../assets/icons/close-cross.svg";

export const CloseButton: React.FC<{ width?: string }> = ({ width = "w-[16px]" }) => {
  return (
    <img src={CloseButtonSVG} alt="" className={ width + " h-[15.88px] cursor-pointer"} />
  )
}
